const Mean_reversion = `
import time
import numpy as np

token = "Your_API_Key"  # Refer to Step 2 in the User Guide above to retrieve your API Key
NSC = NUSwapConnector(token)

symbol = "BTCUSD"  # cyptocurrency code of your choice
pos_held = False

window = 20  # Window size for calculating the mean
threshold = 2  # Number of standard deviations from the mean to trigger a trade

while True:
    print("")
    print("Checking Price")
    
    market_data = NSC.getMarketHistory(symbol)
    
    close_list = []
    for data in market_data:
        close_list.append(data['close'])
    
    close_list = np.array(close_list, dtype=np.float64)
    mean_price = np.mean(close_list[-window:])  # Calculate the mean over the last 'window' periods
    std_dev = np.std(close_list[-window:])  # Calculate the standard deviation over the last 'window' periods
    last_price = close_list[-1]
    
    print("Mean Price: " + str(mean_price))
    print("Standard Deviation: " + str(std_dev))
    print("Last Price: " + str(last_price))
    
    if last_price > mean_price + threshold * std_dev and not pos_held:  # Buy signal
        print("Buy signal detected! Placing order...")
        NSC.placeOrder(symbol, 'Market', 'Buy', 1)  # Placeholder order function. Replace with your implementation.
        pos_held = True
    
    elif last_price < mean_price - threshold * std_dev and pos_held:  # Sell signal
        print("Sell signal detected! Placing order...")
        NSC.placeOrder(symbol, 'Market', 'Sell', 1)  # Placeholder order function. Replace with your implementation.
        pos_held = False
    
    time.sleep(60)  # Sleep for 60 seconds before checking again`

export default Mean_reversion;